const rankingItems = [
  { id: 1, rank: 1, title: '某顶流男星夜会神秘女子事件持续发酵', heat: '128.6万热度', source: '51黑料网站', change: '🔥 飙升' },
  { id: 2, rank: 2, title: '网红带货翻车实录：百万博主直播被扒', heat: '96.3万热度', source: '91黑料网站', change: '📈 上升' },
  { id: 3, rank: 3, title: '选秀节目黑幕录音流出三方联合维权', heat: '215.7万热度', source: '吃瓜黑料网站', change: '🔥 飙升' },
  { id: 4, rank: 4, title: '知名女星代孕疑云再添关键实锤证据', heat: '187.2万热度', source: '51黑料网站', change: '📈 上升' },
  { id: 5, rank: 5, title: '娱乐圈资本对赌协议曝光引行业震动', heat: '73.9万热度', source: '91黑料网站', change: '🆕 新晋' },
  { id: 6, rank: 6, title: '某综艺录制现场发生冲突导演组集体沉默', heat: '62.1万热度', source: '吃瓜黑料网站', change: '➡️ 持平' },
];

export default function RankingSection() {
  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-primary-500 text-white';
    if (rank === 2) return 'bg-primary-400 text-white';
    if (rank === 3) return 'bg-primary-300 text-white';
    return 'bg-background-200 text-foreground-500';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            黑料热度榜
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            实时追踪全网最热黑料话题 Top 6
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {rankingItems.map((item) => (
            <a
              key={item.id}
              href="#"
              className="flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer group"
            >
              <span
                className={`w-9 h-9 flex items-center justify-center rounded-full text-sm font-bold shrink-0 ${getRankStyle(item.rank)}`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 mt-1 flex-wrap">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">来源：{item.source}</span>
                  <span className="text-xs text-accent-600 font-medium whitespace-nowrap">{item.heat}</span>
                </div>
              </div>
              <span className="text-xs font-medium text-primary-600 whitespace-nowrap shrink-0">{item.change}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}